if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();

      
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      
      const container = this.querySelector('[role="document"]');

      if (this.classList.contains('lightbox-zoom-modal')){
        //pop and reinsert the zoom element to the top of container 
        let media = activeMedia.parentElement;
        let mediaContainer = this.querySelector('.product-media-modal__container');
        mediaContainer.insertBefore(media, mediaContainer.firstChild);
        container.scrollTop = 0;
      } else {
        activeMedia.scrollIntoView();        
        
      }
      
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

  });
}
